import React, { useEffect, useState, useRef } from "react";
import { Upload, Flex, Radio, notification, InputNumber, Select } from "antd";
import {
  InboxOutlined,
  InfoCircleOutlined,
  CheckCircleOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import "react-quill/dist/quill.snow.css";
import { Link, useLocation, useNavigate } from "react-router-dom";

import { addEditData } from "../../controllers/exams/ap_exmas";
import { list as academicsList } from "../../controllers/academics/academics";
import { fetchIpAddress } from "../../controllers/API";

import LoadingEffect from "../../components/Loading/LoadingEffect";
import { beforeUpload } from "../../controllers/common";
import ReactQuill from 'react-quill';

const UserListEditPage = () => {
  const { Option } = Select;
  const { Dragger } = Upload;
  const targetRef = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();
  const { state } = location;
  const [error, setError] = useState([]);
  const [ADDEDITDATA, setAddEditSata] = useState(state ? state : "");
  const [isLoading, setIsLoading] = useState(false);

  const [INTRODUCTION, setIntroduction] = useState('');
  const [BENEFITSCONTENT, setBenefitsSectionContent] = useState('');
  const [REGISTRATIONCONTENT, setregistrationContent] = useState('');
  const [SECTIONONECONTENT, setSection1Content] = useState('');
  const [SECTIONTWOCONTENT, setSection2Content] = useState('');
  const [SECTIONTHREECONTENT, setSection3Content] = useState('');
  const [TESTINGPOLICY, setTestingPolicyContent] = useState('');


  /*********************************************************
   *  This function is use to handle imput chnage
   *********************************************************/
  const handleChange = (e) => {
    setAddEditSata((pre) => ({
      ...pre,
      [e.target.name]: e.target.value,
    }));
    setError((pre) => ({
      ...pre,
      [e.target.name]: "",
    }));
  };

  const handleNestedChange = (index, field, value, type) => {
    const updatedCodes = [...ADDEDITDATA[type]];
    updatedCodes[index][field] = value;
    setAddEditSata({ ...ADDEDITDATA, [type]: updatedCodes });
  };

  const addRegularTestingCode = () => {
    setAddEditSata({
      ...ADDEDITDATA,
      regular_testing_codes: [
        ...(ADDEDITDATA.regular_testing_codes || []),
        { name: "", code: "", type: "" },
      ],
    });
  };

  const removeRegTestCodes = (index) => {
    const updatedRegTestedCodes = [...ADDEDITDATA.regular_testing_codes];
    updatedRegTestedCodes.splice(index, 1);
    setAddEditSata((prev) => ({ ...prev, regular_testing_codes: updatedRegTestedCodes }));
    console.log('updatedRegTestedCodes', updatedRegTestedCodes);
  };

  const addLateTestingCode = () => {
    setAddEditSata({
      ...ADDEDITDATA,
      late_testing_codes: [
        ...(ADDEDITDATA.late_testing_codes || []),
        { name: "", code: "" },
      ],
    });
  };

  const removeLateTestCodes = (index) => {
    const updatedLateTestedCodes = [...ADDEDITDATA.late_testing_codes];
    updatedLateTestedCodes.splice(index, 1);
    setAddEditSata((prev) => ({ ...prev, late_testing_codes: updatedLateTestedCodes }));
    console.log('updatedLateTestedCodes', updatedLateTestedCodes);
  };

  /*********************************************************
   *  This function is use to handle form submit
   *********************************************************/
  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    try {
      const {
        _id,
        introduction,
        benefits_section_title,
        benefits_section_content,
        registration_section,
        registration_form_url,
        section1_title,
        section1_content,
        section2_title,
        section2_content,
        section3_title,
        section3_content,
        regular_testing_code_date,
        regular_testing_codes,
        late_testing_code_date,
        late_testing_codes,
        testing_policy_content_title,
        testing_policy_content,
        registration_start_date,
        registration_end_date,
        fee_per_regular_exam,
        fee_per_late_exam,
        contact_phone,
        contact_email,
        contact_name
      } = ADDEDITDATA;
      const ipAddress = (await fetchIpAddress()) || "0.0.0.0";

      const form = new FormData();
      if (_id && _id !== "undefined" && _id !== null) {
        form.append("edit_id", _id);
      }
      form.append("introduction", INTRODUCTION);
      form.append("benefits_section_title", benefits_section_title);
      form.append("benefits_section_content", BENEFITSCONTENT);
      form.append("registration_section", REGISTRATIONCONTENT);
      form.append("registration_form_url", registration_form_url);
      form.append("section1_title", section1_title);
      form.append("section1_content", SECTIONONECONTENT);
      form.append("section2_title", section2_title);
      form.append("section2_content", SECTIONTWOCONTENT);
      form.append("section3_title", section3_title);
      form.append("section3_content", SECTIONTHREECONTENT);
      form.append("regular_testing_code_date", regular_testing_code_date);
      form.append("regular_testing_codes", regular_testing_codes);
      form.append("late_testing_code_date", late_testing_code_date);
      form.append("late_testing_codes", late_testing_codes);
      form.append("testing_policy_content_title", testing_policy_content_title);
      form.append("testing_policy_content", TESTINGPOLICY);
      form.append("registration_start_date", registration_start_date);
      form.append("registration_end_date", registration_end_date);
      form.append("fee_per_regular_exam", fee_per_regular_exam);
      form.append("fee_per_late_exam", fee_per_late_exam);
      form.append("contact_name", contact_name);
      form.append("contact_phone", contact_phone);
      form.append("contact_email", contact_email);

      form.append("ipAddress", ipAddress);

      const isValidate = validateFormData(form);
      if (isValidate) {

        const rawData = {
          edit_id: _id,
          introduction: INTRODUCTION,
          benefits_section_title: benefits_section_title,
          benefits_section_content: BENEFITSCONTENT,
          registration_section: REGISTRATIONCONTENT,
          registration_form_url: registration_form_url,
          section1_title: section1_title,
          section1_content: SECTIONONECONTENT,
          section2_title: section2_title,
          section2_content: SECTIONTWOCONTENT,
          section3_title: section3_title,
          section3_content: SECTIONTHREECONTENT,
          regular_testing_code_date: regular_testing_code_date,
          regular_testing_codes: regular_testing_codes,
          late_testing_code_date: late_testing_code_date,
          late_testing_codes: late_testing_codes,
          testing_policy_content_title: testing_policy_content_title,
          testing_policy_content: TESTINGPOLICY,
          registration_start_date: registration_start_date,
          registration_end_date: registration_end_date,
          fee_per_regular_exam: fee_per_regular_exam,
          fee_per_late_exam: fee_per_late_exam,
          contact_phone: contact_phone,
          contact_email: contact_email,
          contact_name: contact_name
        }
        const options = {
          url: "ap-exams/addeditdata",
          postData: rawData,
        };
        const res = await addEditData(options);
        if (res.status === true) {
          notification.open({
            message: "Data added.",
            description: `Data added Successfully.`,
            placement: "topRight",
            icon: <CheckCircleOutlined style={{ color: "green" }} />,
            duration: 2,
          });
          navigate("/ap-exams");
        } else {
          notification.open({
            message: "Opps!",
            description: `${res?.message}`,
            placement: "topRight",
            icon: <InfoCircleOutlined style={{ color: "red" }} />,
            duration: 2,
          });
        }
      } else {
        notification.open({
          message: "Opps!",
          description: `Please enter the required fields.`,
          placement: "topRight",
          icon: <InfoCircleOutlined style={{ color: "red" }} />,
        });
      }

    } catch (error) {
      console.log("error", error);
    } finally {
      setIsLoading(false);
    }
  };

  const validateFormData = (form) => {
    if (!form.get("introduction").trim() || form.get("introduction").trim() === "undefined" || form.get("introduction").trim() === null) {
      setError((preError) => ({
        ...preError,
        introduction: "Intoduction is required",
      }));
      return false;
    }
    if (!form.get("benefits_section_title").trim() || form.get("benefits_section_title").trim() === "undefined" || form.get("benefits_section_title").trim() === null) {
      setError((preError) => ({
        ...preError,
        benefits_section_title: "Benefits section title is required",
      }));
      return false;
    }
    if (!form.get("benefits_section_content").trim() || form.get("benefits_section_content").trim() === "undefined" || form.get("benefits_section_content").trim() === null) {
      setError((preError) => ({
        ...preError,
        benefits_section_content: "Benefits section content is required",
      }));
      return false;
    }
    if (!form.get("registration_section").trim() || form.get("registration_section").trim() === "undefined" || form.get("registration_section").trim() === null) {
      setError((preError) => ({
        ...preError,
        registration_section: "Registration section is required",
      }));
      return false;
    }
    if (!form.get("section1_title").trim() || form.get("section1_title").trim() === "undefined" || form.get("section1_title").trim() === null) {
      setError((preError) => ({
        ...preError,
        section1_title: "Section 1 title is required",
      }));
      return false;
    }
    if (!form.get("section1_content").trim() || form.get("section1_content").trim() === "undefined" || form.get("section1_content").trim() === null) {
      setError((preError) => ({
        ...preError,
        section1_content: "Section 1 content is required",
      }));
      return false;
    }
    if (!form.get("section2_title").trim() || form.get("section2_title").trim() === "undefined" || form.get("section2_title").trim() === null) {
      setError((preError) => ({
        ...preError,
        section2_title: "Section 2 title is required",
      }));
      return false;
    }
    if (!form.get("section2_content").trim() || form.get("section2_content").trim() === "undefined" || form.get("section2_content").trim() === null) {
      setError((preError) => ({
        ...preError,
        section2_content: "Section 2 content is required",
      }));
      return false;
    }
    if (!form.get("section3_title").trim() || form.get("section3_title").trim() === "undefined" || form.get("section3_title").trim() === null) {
      setError((preError) => ({
        ...preError,
        section3_title: "Section 3 title is required",
      }));
      return false;
    }
    if (!form.get("section3_content").trim() || form.get("section3_content").trim() === "undefined" || form.get("section3_content").trim() === null) {
      setError((preError) => ({
        ...preError,
        section3_content: "Section 3 content is required",
      }));
      return false;
    }
    if (!form.get("regular_testing_code_date") || form.get("regular_testing_code_date") === "undefined" || form.get("regular_testing_code_date") === null) {
      setError((preError) => ({
        ...preError,
        regular_testing_code_date: "Regular testing code date is required",
      }));
      return false;
    }
    if (!form.get("late_testing_code_date").trim() || form.get("late_testing_code_date").trim() === "undefined" || form.get("late_testing_code_date").trim() === null) {
      setError((preError) => ({
        ...preError,
        late_testing_code_date: "Late testing code date is required",
      }));
      return false;
    }
    if (!form.get("testing_policy_content_title").trim() || form.get("testing_policy_content_title").trim() === "undefined" || form.get("testing_policy_content_title").trim() === null) {
      setError((preError) => ({
        ...preError,
        testing_policy_content_title: "Testing policy title is required",
      }));
      return false;
    }
    if (!form.get("testing_policy_content").trim() || form.get("testing_policy_content").trim() === "undefined" || form.get("testing_policy_content").trim() === null) {
      setError((preError) => ({
        ...preError,
        testing_policy_content: "Testing policy content is required",
      }));
      return false;
    }
    if (!form.get("registration_start_date") || form.get("registration_start_date") === "undefined" || form.get("registration_start_date") === null) {
      setError((preError) => ({
        ...preError,
        registration_start_date: "Registration start date is required",
      }));
      return false;
    }
    if (!form.get("registration_end_date") || form.get("registration_end_date") === "undefined" || form.get("registration_end_date") === null) {
      setError((preError) => ({
        ...preError,
        registration_end_date: "Registration end date is required",
      }));
      return false;
    }
    if (!form.get("fee_per_regular_exam") || form.get("fee_per_regular_exam") === "undefined" || form.get("fee_per_regular_exam") === null) {
      setError((preError) => ({
        ...preError,
        fee_per_regular_exam: "Regular exam fee is required",
      }));
      return false;
    }
    if (!form.get("fee_per_late_exam") || form.get("fee_per_late_exam") === "undefined" || form.get("fee_per_late_exam") === null) {
      setError((preError) => ({
        ...preError,
        fee_per_late_exam: "Late exam fee is required",
      }));
      return false;
    }
    if (!form.get("contact_name").trim() || form.get("contact_name").trim() === "undefined" || form.get("contact_name").trim() === null) {
      setError((preError) => ({
        ...preError,
        contact_name: "Name is required",
      }));
      return false;
    }
    if (!form.get("contact_phone").trim() || form.get("contact_phone").trim() === "undefined" || form.get("contact_phone").trim() === null) {
      setError((preError) => ({
        ...preError,
        contact_phone: "Phone is required",
      }));
      return false;
    }
    if (!form.get("contact_email").trim() || form.get("contact_email").trim() === "undefined" || form.get("contact_email").trim() === null) {
      setError((preError) => ({
        ...preError,
        contact_email: "Email is required",
      }));
      return false;
    }
    return true;
  };

  useEffect(() => {
    targetRef.current.scrollIntoView({
      behavior: 'smooth',
    });
    setIntroduction(ADDEDITDATA?.introduction);
    setBenefitsSectionContent(ADDEDITDATA?.benefits_section_content);
    setregistrationContent(ADDEDITDATA?.registration_section);
    setSection1Content(ADDEDITDATA?.section1_content);
    setSection2Content(ADDEDITDATA?.section2_content);
    setSection3Content(ADDEDITDATA?.section3_content);
    setTestingPolicyContent(ADDEDITDATA?.testing_policy_content);
    document.title = `KC High Super Admin || ${ADDEDITDATA?._id ? "Edit" : "Add"
      } AP Exams`;
  }, []);

  return (
    <div ref={targetRef}>
      {" "}
      <div className="container-fluid">
        <div className="Inventory_edit_page_main_div">
          <div>
            <h5 className="inventory_edit_page_heading">
              {ADDEDITDATA?._id ? `Edit` : `Add`} AP Exams
            </h5>
          </div>
          <Link to="/ap-exams">
            <div>
              <button type="button" className="btn btn-secondary">
                <ArrowLeftOutlined /> Back
              </button>
            </div>
          </Link>
        </div>

        <div className="card shadow mb-4 dataBase_table_Add_Data">
          <div className="card-body">
            <div className="responsive">
              <form method="post" className="inventory_form_main_contnet">
                <div className="row">
                  <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="introduction"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                      <span style={{ color: "red" }}>*</span>Introduction :{" "}
                    </label>
                    <ReactQuill
                      theme="snow"
                      value={INTRODUCTION || ''}
                      onChange={setIntroduction}
                    />
                    {error.introduction ? (
                      <p style={{ color: "red" }}>
                        {error.introduction}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="benefits_section_title"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                      <span style={{ color: "red" }}>*</span>Benefits Section Title :{" "}
                    </label>
                    <input
                      title="Enter benefits section title"
                      placeholder="Enter benefits section title"
                      type="text"
                      name="benefits_section_title"
                      className="form-control store_input_field"
                      id="benefits_section_title"
                      value={ADDEDITDATA?.benefits_section_title}
                      onChange={handleChange}
                    />
                    {error.benefits_section_title ? (
                      <p style={{ color: "red" }}>
                        {error.benefits_section_title}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="benefits_section_content"
                      className="all_section_for_label_main_class  all_lebel_margin_top_main_div"
                    >
                      <span style={{ color: "red" }}>*</span>Benefits Section Content :
                    </label>
                    <ReactQuill
                      theme="snow"
                      value={BENEFITSCONTENT || ''}
                      onChange={setBenefitsSectionContent}
                    />
                    {error.benefits_section_content ? (
                      <p style={{ color: "red" }}>{error.benefits_section_content}</p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="registration_section"
                      className="all_section_for_label_main_class  all_lebel_margin_top_main_div"
                    >
                      <span style={{ color: "red" }}>*</span>Registration Section Content :
                    </label>
                    <ReactQuill
                      theme="snow"
                      value={REGISTRATIONCONTENT || ''}
                      onChange={setregistrationContent}
                    />
                    {error.registration_section ? (
                      <p style={{ color: "red" }}>{error.registration_section}</p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="registration_form_url"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                      Registration Form URL :{" "}
                    </label>
                    <input
                      title="Enter the KC High registration form link (Google Form URL)"
                      placeholder="https://forms.gle/..."
                      type="text"
                      name="registration_form_url"
                      className="form-control store_input_field"
                      id="registration_form_url"
                      value={ADDEDITDATA?.registration_form_url}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="section1_title"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                      <span style={{ color: "red" }}>*</span>Section 1 Title :{" "}
                    </label>
                    <input
                      title="Enter section 1 title"
                      placeholder="Enter section 1 title"
                      type="text"
                      name="section1_title"
                      className="form-control store_input_field"
                      id="section1_title"
                      value={ADDEDITDATA?.section1_title}
                      onChange={handleChange}
                    />
                    {error.section1_title ? (
                      <p style={{ color: "red" }}>
                        {error.section1_title}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="section1_content"
                      className="all_section_for_label_main_class  all_lebel_margin_top_main_div"
                    >
                      <span style={{ color: "red" }}>*</span>Section 1 Content :
                    </label>
                    <ReactQuill
                      theme="snow"
                      value={SECTIONONECONTENT || ''}
                      onChange={setSection1Content}
                    />
                    {error.section1_content ? (
                      <p style={{ color: "red" }}>{error.section1_content}</p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="section2_title"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                      <span style={{ color: "red" }}>*</span>Section 2 Title :{" "}
                    </label>
                    <input
                      title="Enter section 2 title"
                      placeholder="Enter section 2 title"
                      type="text"
                      name="section2_title"
                      className="form-control store_input_field"
                      id="section2_title"
                      value={ADDEDITDATA?.section2_title}
                      onChange={handleChange}
                    />
                    {error.section2_title ? (
                      <p style={{ color: "red" }}>
                        {error.section2_title}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="section2_content"
                      className="all_section_for_label_main_class  all_lebel_margin_top_main_div"
                    >
                      <span style={{ color: "red" }}>*</span>Section 2 Content :
                    </label>
                    <ReactQuill
                      theme="snow"
                      value={SECTIONTWOCONTENT || ''}
                      onChange={setSection2Content}
                    />
                    {error.section2_content ? (
                      <p style={{ color: "red" }}>{error.section2_content}</p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="section3_title"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                      <span style={{ color: "red" }}>*</span>Section 3 Title :{" "}
                    </label>
                    <input
                      title="Enter section 3 title"
                      placeholder="Enter section 3 title"
                      type="text"
                      name="section3_title"
                      className="form-control store_input_field"
                      id="section3_title"
                      value={ADDEDITDATA?.section3_title}
                      onChange={handleChange}
                    />
                    {error.section3_title ? (
                      <p style={{ color: "red" }}>
                        {error.section3_title}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="section3_content"
                      className="all_section_for_label_main_class  all_lebel_margin_top_main_div"
                    >
                      <span style={{ color: "red" }}>*</span>Section 3 Content :
                    </label>
                    <ReactQuill
                      theme="snow"
                      value={SECTIONTHREECONTENT || ''}
                      onChange={setSection3Content}
                    />
                    {error.section3_content ? (
                      <p style={{ color: "red" }}>{error.section3_content}</p>
                    ) : (
                      ""
                    )}
                  </div>
                  <h4 className="mt-5">Regular testing code details</h4>
                  <hr></hr>
                  <div className="form-group col-lg-10 col-md-10 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="regular_testing_code_date"
                      className="all_section_for_label_main_class"
                    >
                      <span style={{ color: "red" }}>*</span>Regular testing date :{" "}
                    </label>
                    <input
                      title="Enter Regular testing date"
                      placeholder="Enter Regular testing date"
                      type="text"
                      name="regular_testing_code_date"
                      className="form-control store_input_field"
                      id="regular_testing_code_date"
                      value={ADDEDITDATA?.regular_testing_code_date}
                      onChange={handleChange}
                    />
                    {error.regular_testing_code_date ? (
                      <p style={{ color: "red" }}>
                        {error.regular_testing_code_date}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-2 col-md-2 col-sm-12 col-xs-12 vendor_Add_edit_data mt-5">
                    <button type="button" onClick={addRegularTestingCode} className="btn btn-primary">Add Test code</button>
                  </div>
                  {ADDEDITDATA?.regular_testing_codes?.map((regular_testing_code, regularTestingCodesIndex) => (
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" key={regularTestingCodesIndex}>
                      <div className="row">
                        <div className="form-group col-lg-4 col-md-4-sm-12 col-xs-12 vendor_Add_edit_data">
                          <label className="all_section_for_label_main_class all_lebel_margin_top_main_div">
                            <span style={{ color: "red" }}>*</span>Test name :{" "}
                          </label>
                          <input
                            placeholder="Test name"
                            value={regular_testing_code.name}
                            onChange={(e) =>
                              handleNestedChange(regularTestingCodesIndex, "name", e.target.value, "regular_testing_codes")
                            }
                            type="text"
                            className="form-control store_input_field"
                          />
                        </div>
                        <div className="form-group col-lg-3 col-md-3-sm-12 col-xs-12 vendor_Add_edit_data">
                          <label className="all_section_for_label_main_class all_lebel_margin_top_main_div">
                            <span style={{ color: "red" }}>*</span>Test code :{" "}
                          </label>
                          <input
                            placeholder="Test code"
                            value={regular_testing_code.code}
                            onChange={(e) =>
                              handleNestedChange(regularTestingCodesIndex, "code", e.target.value, "regular_testing_codes")
                            }
                            type="text"
                            className="form-control store_input_field"
                          />
                        </div>
                        <div className="form-group col-lg-3 col-md-3-sm-12 col-xs-12 vendor_Add_edit_data">
                          <label className="all_section_for_label_main_class all_lebel_margin_top_main_div">
                            <span style={{ color: "red" }}>*</span>Test type :{" "}
                          </label>
                          <input
                            placeholder="Test type"
                            value={regular_testing_code.type}
                            onChange={(e) =>
                              handleNestedChange(regularTestingCodesIndex, "type", e.target.value, "regular_testing_codes")
                            }
                            type="text"
                            className="form-control store_input_field"
                          />
                        </div>
                        <div className="form-group col-lg-2 col-md-2 col-sm-12 col-xs-12 vendor_Add_edit_data mt-5">
                          <button type="button" onClick={() => removeRegTestCodes(regularTestingCodesIndex)} className="btn btn-primary">Remove Item</button>
                        </div>
                      </div>
                    </div>
                  ))}

                  <h4 className="mt-5">Late testing code details</h4>
                  <hr></hr>
                  <div className="form-group col-lg-10 col-md-10 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="late_testing_code_date"
                      className="all_section_for_label_main_class"
                    >
                      <span style={{ color: "red" }}>*</span>Late testing date :{" "}
                    </label>
                    <input
                      title="Enter late testing date"
                      placeholder="Enter late testing date"
                      type="text"
                      name="late_testing_code_date"
                      className="form-control store_input_field"
                      id="late_testing_code_date"
                      value={ADDEDITDATA?.late_testing_code_date}
                      onChange={handleChange}
                    />
                    {error.late_testing_code_date ? (
                      <p style={{ color: "red" }}>
                        {error.late_testing_code_date}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-2 col-md-2 col-sm-12 col-xs-12 vendor_Add_edit_data mt-5">
                    <button type="button" onClick={addLateTestingCode} className="btn btn-primary">Add Test code</button>
                  </div>
                  {ADDEDITDATA?.late_testing_codes?.map((regular_testing_code, lateTestingCodesIndex) => (
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" key={lateTestingCodesIndex}>
                      <div className="row">
                        <div className="form-group col-lg-4 col-md-4-sm-12 col-xs-12 vendor_Add_edit_data">
                          <label className="all_section_for_label_main_class all_lebel_margin_top_main_div">
                            <span style={{ color: "red" }}>*</span>Test name :{" "}
                          </label>
                          <input
                            placeholder="Test name"
                            value={regular_testing_code.name}
                            onChange={(e) =>
                              handleNestedChange(lateTestingCodesIndex, "name", e.target.value, "late_testing_codes")
                            }
                            type="text"
                            className="form-control store_input_field"
                          />
                        </div>
                        <div className="form-group col-lg-3 col-md-3-sm-12 col-xs-12 vendor_Add_edit_data">
                          <label className="all_section_for_label_main_class all_lebel_margin_top_main_div">
                            <span style={{ color: "red" }}>*</span>Test code :{" "}
                          </label>
                          <input
                            placeholder="Test code"
                            value={regular_testing_code.code}
                            onChange={(e) =>
                              handleNestedChange(lateTestingCodesIndex, "code", e.target.value, "late_testing_codes")
                            }
                            type="text"
                            className="form-control store_input_field"
                          />
                        </div>
                        <div className="form-group col-lg-3 col-md-3-sm-12 col-xs-12 vendor_Add_edit_data">
                          <label className="all_section_for_label_main_class all_lebel_margin_top_main_div">
                            <span style={{ color: "red" }}>*</span>Test type :{" "}
                          </label>
                          <input
                            placeholder="Test type"
                            value={regular_testing_code.type}
                            onChange={(e) =>
                              handleNestedChange(lateTestingCodesIndex, "type", e.target.value, "late_testing_codes")
                            }
                            type="text"
                            className="form-control store_input_field"
                          />
                        </div>
                        <div className="form-group col-lg-2 col-md-2 col-sm-12 col-xs-12 vendor_Add_edit_data mt-5">
                          <button type="button" onClick={() => removeLateTestCodes(lateTestingCodesIndex)} className="btn btn-primary">Remove Item</button>
                        </div>
                      </div>
                    </div>
                  ))}
                  <h4 className="mt-5">Testing policy</h4>
                  <hr></hr>
                  <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="testing_policy_content_title"
                      className="all_section_for_label_main_class"
                    >
                      <span style={{ color: "red" }}>*</span>Testing Policy Title :{" "}
                    </label>
                    <input
                      title="Enter testing policy title"
                      placeholder="Enter testing policy title"
                      type="text"
                      name="testing_policy_content_title"
                      className="form-control store_input_field"
                      id="testing_policy_content_title"
                      value={ADDEDITDATA?.testing_policy_content_title}
                      onChange={handleChange}
                    />
                    {error.testing_policy_content_title ? (
                      <p style={{ color: "red" }}>
                        {error.testing_policy_content_title}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="testing_policy_content"
                      className="all_section_for_label_main_class  all_lebel_margin_top_main_div"
                    >
                      <span style={{ color: "red" }}>*</span>Testing policy content :
                    </label>
             <ReactQuill
  theme="snow"
  value={TESTINGPOLICY || ''}
  onChange={setTestingPolicyContent}
  modules={{
    toolbar: [
      [{ header: [1, 2, 3, 4, 5, 6, false] }], // Adds H1-H6 + Normal text
      ["bold", "italic", "underline", "strike"], // Text styles
      [{ list: "ordered" }, { list: "bullet" }], // Lists
      ["link"], // Links
      ["clean"], // Remove formatting
    ],
  }}
/>

                    {error.testing_policy_content ? (
                      <p style={{ color: "red" }}>{error.testing_policy_content}</p>
                    ) : (
                      ""
                    )}
                  </div>
                  <h4 className="mt-5">Registraion timeline</h4>
                  <hr></hr>
                  <div className="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="registration_start_date"
                      className="all_section_for_label_main_class"
                    >
                      <span style={{ color: "red" }}>*</span>Registration start date ( For Regular & Late exams) :{" "}
                    </label>
                    <input
                      title="Enter registration start date"
                      placeholder="Enter registration start date"
                      type="text"
                      name="registration_start_date"
                      className="form-control store_input_field"
                      id="registration_start_date"
                      value={ADDEDITDATA?.registration_start_date}
                      onChange={handleChange}
                    />
                    {error.registration_start_date ? (
                      <p style={{ color: "red" }}>
                        {error.registration_start_date}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="registration_end_date"
                      className="all_section_for_label_main_class"
                    >
                      <span style={{ color: "red" }}>*</span>Registration end date ( For Regular & Late exams ) :{" "}
                    </label>
                    <input
                      title="Enter registration end date"
                      placeholder="Enter registration end date"
                      type="text"
                      name="registration_end_date"
                      className="form-control store_input_field"
                      id="registration_end_date"
                      value={ADDEDITDATA?.registration_end_date}
                      onChange={handleChange}
                    />
                    {error.registration_end_date ? (
                      <p style={{ color: "red" }}>
                        {error.registration_end_date}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="fee_per_regular_exam"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                      <span style={{ color: "red" }}>*</span>AP Exam Fee (INR) per subject Regular Exam :{" "}
                    </label>
                    <input
                      title="AP Exam Fee (INR) per subject Regular Exam"
                      placeholder="AP Exam Fee (INR) per subject Regular Exam"
                      type="text"
                      name="fee_per_regular_exam"
                      className="form-control store_input_field"
                      id="fee_per_regular_exam"
                      value={ADDEDITDATA?.fee_per_regular_exam}
                      onChange={handleChange}
                    />
                    {error.fee_per_regular_exam ? (
                      <p style={{ color: "red" }}>
                        {error.fee_per_regular_exam}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="fee_per_late_exam"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                      <span style={{ color: "red" }}>*</span>AP Exam Fee (INR) per subject Late Exam :{" "}
                    </label>
                    <input
                      title="AP Exam Fee (INR) per subject Late Exam"
                      placeholder="AP Exam Fee (INR) per subject Late Exam"
                      type="text"
                      name="fee_per_late_exam"
                      className="form-control store_input_field"
                      id="fee_per_late_exam"
                      value={ADDEDITDATA?.fee_per_late_exam}
                      onChange={handleChange}
                    />
                    {error.fee_per_late_exam ? (
                      <p style={{ color: "red" }}>
                        {error.fee_per_late_exam}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <h4 className="mt-5">Contacts details</h4>
                  <hr></hr>
                  <div className="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="contact_name"
                      className="all_section_for_label_main_class"
                    >
                      <span style={{ color: "red" }}>*</span>Contact name :{" "}
                    </label>
                    <input
                      title="Contact name"
                      placeholder="Contact name"
                      type="text"
                      name="contact_name"
                      className="form-control store_input_field"
                      id="contact_name"
                      value={ADDEDITDATA?.contact_name}
                      onChange={handleChange}
                    />
                    {error.contact_name ? (
                      <p style={{ color: "red" }}>
                        {error.contact_name}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="contact_phone"
                      className="all_section_for_label_main_class"
                    >
                      <span style={{ color: "red" }}>*</span>Contact phone :{" "}
                    </label>
                    <input
                      title="Contact phone"
                      placeholder="Contact phone"
                      type="text"
                      name="contact_phone"
                      className="form-control store_input_field"
                      id="contact_phone"
                      value={ADDEDITDATA?.contact_phone}
                      onChange={handleChange}
                    />
                    {error.contact_phone ? (
                      <p style={{ color: "red" }}>
                        {error.contact_phone}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="contact_email"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                      <span style={{ color: "red" }}>*</span>Contact email :{" "}
                    </label>
                    <input
                      title="Contact email"
                      placeholder="Contact email"
                      type="text"
                      name="contact_email"
                      className="form-control store_input_field"
                      id="contact_email"
                      value={ADDEDITDATA?.contact_email}
                      onChange={handleChange}
                    />
                    {error.contact_email ? (
                      <p style={{ color: "red" }}>
                        {error.contact_email}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <div className="inventory_edit_submit_btn">
                  <button
                    type="button"
                    className="btn btn-primary inventory_save_button"
                    onClick={handleSubmit}
                  >
                    Save
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <LoadingEffect isLoading={isLoading} />
    </div>
  );
};

export default UserListEditPage;
